"use client";

import { Employer, GovernmentEmployer } from "@entities/employer";
import { DetailItem } from "@shared/ui";

export function GovernmentEmployerPicDetails({ employer }: { employer: Employer }) {
  const government = employer.employerable as GovernmentEmployer;

  if (!employer || !government) return <></>;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
      <div>
        <DetailItem label="Nama PIC" value={government.picName || "-"} />
      </div>
      <div>
        <DetailItem label="NIK PIC" value={government.picIdNumber || "-"} />
      </div>
      <div>
        <DetailItem label="Email PIC" value={government.picEmail || "-"} />
      </div>
      <div>
        <DetailItem label="Nomor telepon PIC" value={government.picPhone ? `+62 ${government.picPhone}` : "-"} />
      </div>
    </div>
  );
}
